import { ButtonWithAnimation } from "@/components/Button";

export function TestPage() {
  return (
    <div className="w-full h-full">
      <ButtonWithAnimation className="uppercase!" variant="filled">
        Cпальня
      </ButtonWithAnimation>
    </div>
  );
}
